module.exports = __webpack_public_path__ + "img/D202004_3.55d9a8c3.jpg";